import Vue from 'vue'
import Router from 'vue-router'

import AccountLayout from '@/components/account/Layout'
import Login from '@/components/account/Login'
import RouteLogin from '@/components/account/RouteLogin'
import HomeLayout from '@/components/home/Layout'
import UserManagementLayout from '@/components/account/Layout'

import Home from '@/components/home/Home'

//Airfield Pavement Components
const AirfieldPavementAreaLayout = () => import(/* webpackChunkName: "airfield-pavement" */ '@/components/airfield-pavement-area/Layout')
const Resurfacing = () => import(/* webpackChunkName: "airfield-pavement" */ '@/components/airfield-pavement-area/Resurfacing')
const PavementAge = () => import(/* webpackChunkName: "airfield-pavement" */ '@/components/airfield-pavement-area/PavementAge')
const PavementCoreRecords = () => import(/* webpackChunkName: "airfield-pavement" */ '@/components/airfield-pavement-area/PavementCoreRecords')
const Defects = () => import(/* webpackChunkName: "airfield-pavement" */ '@/components/airfield-pavement-area/Defects')
const AirfieldMaintenance = () => import(/* webpackChunkName: "airfield-pavement" */ '@/components/airfield-pavement-area/Maintenance')
const PCI = () => import(/* webpackChunkName: "airfield-pavement" */ '@/components/airfield-pavement-area/PCI')
const PCN = () => import(/* webpackChunkName: "airfield-pavement" */ '@/components/airfield-pavement-area/PCN')
const Heaving = () => import(/* webpackChunkName: "airfield-pavement" */ '@/components/airfield-pavement-area/Heaving')

const SetupResurfacingContractColorPanel = () => import(/* webpackChunkName: "airfield-pavement" */ "@/components/airfield-pavement-area/ui-components/SetupResurfacingContractColorPanel")

const KitchenSink  = () => import(/* webpackChunkName: "airfield-pavement" */ '@/components/airfield-pavement-area/KitchenSink')

const AirfieldAuditLog  = () => import(/* webpackChunkName: "airfield-pavement" */ '@/components/airfield-pavement-area/AuditLog')

//High Mast Lighting Components
import HighMastLightingAreaLayout from '@/components/high-mast-lighting-area/Layout'
const NewBasicMap = () =>import ( /* webpackChunkName: "high-mash-lighting" */ '@/components/high-mast-lighting-area/NewBasicMap')
const HMLNetwork = () =>
  import ( /* webpackChunkName: "high-mash-lighting" */ '@/components/high-mast-lighting-area/HMLNetwork')
  const HMLAsset = () =>
    import ( /* webpackChunkName: "high-mash-lighting" */ '@/components/high-mast-lighting-area/Asset')
const LuxMeasurement = () =>
  import ( /* webpackChunkName: "high-mash-lighting" */ '@/components/high-mast-lighting-area/LuxMeasurement')
const PowerSource = () =>
  import ( /* webpackChunkName: "high-mash-lighting" */ '@/components/high-mast-lighting-area/PowerSource')
const SafetyCert = () =>
  import ( /* webpackChunkName: "high-mash-lighting" */ '@/components/high-mast-lighting-area/SafetyCert')
const AircraftReceptacle = () =>
  import ( /* webpackChunkName: "high-mash-lighting" */ '@/components/high-mast-lighting-area/AircraftReceptacle')
const HMLAamsAsset = () =>
  import ( /* webpackChunkName: "high-mash-lighting" */ '@/components/high-mast-lighting-area/AAMSAsset')

//Potable Water Components
const PotableWaterAreaLayout = () => import(/* webpackChunkName: "potable-water" */ '@/components/potable-water-area/Layout')
const WaterNetwork = () => import(/* webpackChunkName: "potable-water" */ '@/components/potable-water-area/WaterNetwork')
const LeakageDetection = () => import(/* webpackChunkName: "potable-water" */ '@/components/potable-water-area/LeakageDetection')
const Intake = () => import(/* webpackChunkName: "potable-water" */ '@/components/potable-water-area/Intake')
const Simulation = () => import(/* webpackChunkName: "potable-water" */ '@/components/potable-water-area/Simulation')
const AssetAge = () =>
  import( /* webpackChunkName: "potable-water" */ '@/components/potable-water-area/AssetAge')
const PotableWaterMaintenance = () => import(/* webpackChunkName: "potable-water" */ '@/components/potable-water-area/Maintenance')
const Inspection = () => import(/* webpackChunkName: "potable-water" */ '@/components/potable-water-area/Inspection')
const PotableWaterWelcome = () => import(/* webpackChunkName: "potable-water" */ '@/components/potable-water-area/Welcome')
const WaterNetworkTableView = () => import(/* webpackChunkName: "potable-water" */ '@/components/potable-water-area/WaterNetworkTableView')
const POTAamsAsset = () => import(/* webpackChunkName: "potable-water" */ '@/components/potable-water-area/AAMSAsset')

//Airfield Ground Light Components
import AGLAreaLayout from '@/components/airfield-ground-light-area/Layout'
const AGLWelcome = () =>
  import ( /* webpackChunkName: "airfield-ground-light" */ '@/components/airfield-ground-light-area/Welcome')
 const AGLAsset = () =>
   import ( /* webpackChunkName: "airfield-ground-light" */ '@/components/airfield-ground-light-area/Asset')
 const AGLReplacement = () =>
   import ( /* webpackChunkName: "airfield-ground-light" */ '@/components/airfield-ground-light-area/Replacement')
 const AGLBoltInsp = () =>
   import ( /* webpackChunkName: "airfield-ground-light" */ '@/components/airfield-ground-light-area/BoltInspection')
 const AGLEpoxyInsp = () =>
   import ( /* webpackChunkName: "airfield-ground-light" */ '@/components/airfield-ground-light-area/EpoxyInspection')
 const AGLAnalysis = () =>
   import ( /* webpackChunkName: "airfield-ground-light" */ '@/components/airfield-ground-light-area/Analysis')
 const AGLPhotometric = () =>
   import ( /* webpackChunkName: "airfield-ground-light" */ '@/components/airfield-ground-light-area/Photometric')
const AGLAAMSAsset = () =>
   import ( /* webpackChunkName: "airfield-ground-light" */ '@/components/airfield-ground-light-area/AAMSAsset')

//Sewer Components
import SewerAreaLayout from '@/components/sewer-area/Layout'
const SewerWelcome = () => import(/* webpackChunkName: "sewer-water" */ '@/components/sewer-area/Welcome')
const SewerAsset = () => import(/* webpackChunkName: "sewer-water" */ '@/components/sewer-area/Asset')
const SewerMaintenance = () => import(/* webpackChunkName: "sewer-water" */ '@/components/sewer-area/Maintenance')
const SewerCCTV = () => import(/* webpackChunkName: "sewer-water" */ '@/components/sewer-area/CCTV')
const SewerRelining = () => import(/* webpackChunkName: "sewer-water" */ '@/components/sewer-area/Relining')
const SewerSimulation = () => import(/* webpackChunkName: "sewer-water" */ '@/components/sewer-area/Simulation')
const SewerAAMSAsset = () => import(/* webpackChunkName: "sewer-water" */ '@/components/sewer-area/AAMSAsset')
//User Management Components
import UserManagement from '@/components/account/UserManagement'

import Welcome from '@/components/ui-components/Welcome'
import RouteWelcome from '@/components/ui-components/RouteWelcome'

const router =  new Router({
  mode: 'history',
  base: process.env.__APP_BASE_PATH__,
  routes: [
    {

        path: '/', component: AccountLayout,
        children: [
            {
              name: 'RouteLogin',
              path: '',
              component: RouteLogin
            },
        ]
    },
    {

      path: '/Login',
      component: AccountLayout,
      children: [{
        name: 'Login',
        path: '',
        component: Login
      }, ]
    },
    {
      path: '/home',
      component: HomeLayout,
      title: 'Airport GIS',
      children: [{
        name: 'Home',
        path: '',
        component: Home,
        meta: {
          title: null,
          requiresAuth: false
        }
      }]
    },
    {
      component: UserManagementLayout,
      path: '/user-management',
      children: [{
        name: 'user management',
        path: '',
        component: UserManagement,
        meta: {
          title: 'User Management',
         requiresAuth: true,
         requiresAuthKey: 'AGIS_ADMIN',
         requiresAuthLevel: 3
        },
      }],
    },
    {
      path: '/airfield-pavement-area',
      component: AirfieldPavementAreaLayout,
      children: [
        {
          name: 'Resurfacing',
          path: 'resurfacing',
          component: Resurfacing,
          meta: {
            title:'Resurfacing',
            requiresAuth: true,
            requiresAuthKey: 'PAVE_RESURFACING',
            requiresAuthAdminKey: 'PAVE_ADMIN'
          }
        },
        {
          name: 'Pavement Age',
          path: 'pavement-age',
          component: PavementAge,
          meta: {
            title:'Pavement Age',
            requiresAuth: true,
            requiresAuthKey: 'PAVE_AGE',
            requiresAuthAdminKey: 'PAVE_ADMIN'
          }
        },
        {
          name: 'Core Records',
          path: 'pavement-core-records',
          component: PavementCoreRecords,
          meta: {
            title:'Core Records',
            requiresAuth: true,
            requiresAuthKey: 'PAVE_CORE_RECORDS',
            requiresAuthAdminKey: 'PAVE_ADMIN'
          }
        },
        {
          name: 'Heaving',
          path: 'heaving',
          component: Heaving,
          meta: {
            title:'Heaving',
            requiresAuth: true,
            requiresAuthKey: 'PAVE_HEAVING',
            requiresAuthAdminKey: 'PAVE_ADMIN'
          }
        },
        {
          name: 'PCI',
          path: 'pci',
          component: PCI,
          meta: {
            title:'PCI',
            requiresAuth: true,
            requiresAuthKey: 'PAVE_PCI',
            requiresAuthAdminKey: 'PAVE_ADMIN'
          }
        },
        {
          name: 'PCN',
          path: 'pcn',
          component: PCN,
          meta: {
            title:'PCN',
            requiresAuth: true,
            requiresAuthKey: 'PAVE_PCN',
            requiresAuthAdminKey: 'PAVE_ADMIN'
          }
        },
        {
          name: 'Defects',
          path: 'defects',
          component: Defects,
          meta: {
            title:'Defects',
            requiresAuth: true,
            requiresAuthKey: 'PAVE_DEFECTS',
            requiresAuthAdminKey: 'PAVE_ADMIN'
          }
        },
        {
          name: 'Airfield Maintenance',
          path: 'maintenance',
          component: AirfieldMaintenance,
          meta: {
            title:'Maintenance',
            requiresAuth: true,
            requiresAuthKey: 'PAVE_MAINTENANCE',
            requiresAuthAdminKey: 'PAVE_ADMIN'
          }
        },
        {
          name: 'Audit Log',
          path: 'audit-log',
          component: AirfieldAuditLog,
          meta:{
            title:'Audit Log',
            requiresAuth: true,
            requiresAuthKey: 'PAVE_ADMIN',
            requiresAuthLevel: 3
          }
        },
        {
          name: 'Kitchen Sink',
          path: 'kitchen-sink',
          component: KitchenSink
        },
        {
          name: 'Contract Management',
          path: 'contract-management',
          component: SetupResurfacingContractColorPanel,
          meta: {
            title:'Contract Management',
            requiresAuth: true,
            requiresAuthKey: 'PAVE_ADMIN',
            requiresAuthLevel: 3
          }
        },
        {
          name: 'Airfield',
          path: '',
          component: RouteWelcome,
          props: {
            systemHome: "/airfield-pavement-area/welcome"
          }
        },
        {
          name: 'Airfield Welcome',
          path: 'welcome',
          component: Welcome,
          props: {
            headerText: 'Enterprise GIS - Airfield Pavement System',
            staticBackground: 'static/bg_aps.jpg'
          },
          meta:{
            title:'Welcome',
            requiresAuthKey: 'PAVE_ADMIN',
            requiresAuthLevel: 1
          }
        },
      ]
    },
    {
      path: '/high-mast-lighting-area', component: HighMastLightingAreaLayout,
        children: [
            {
              name: 'HMLNetwork',
              path: 'hml-network',
              component: HMLNetwork,
              meta: {
                title: 'Network',
                requiresAuth: true,
                requiresAuthKey: 'HML_NETWORK'
              }
            }, {
              name: 'Asset',
              path: 'asset',
              component: HMLAsset,
              meta: {
                title: 'Asset'
              }
            }, {
              name: 'Lux Measurement',
              path: 'lux-measurement',
              component: LuxMeasurement,
              meta: {
                title: 'Lux Measurement',
                requiresAuth: true,
                requiresAuthKey: 'HML_LUX'
              }
            }, {
              name: 'Power Source',
              path: 'power-source',
              component: PowerSource,
              meta: {
                title: 'Power Source',
                requiresAuth: true,
                requiresAuthKey: 'HML_POWER_SOURCE'
              }
            }, {
              name: 'Safety Certificate',
              path: 'safety-certificate',
              component: SafetyCert,
              meta: {
                title: 'Safety Certificate'
              }
            }, {
              name: 'Aircraft Earth Receptacle',
              path: 'aircraft-earth-receptacle',
              component: AircraftReceptacle,
              meta: {
                title: 'Aircraft Earth Receptacle',
                requiresAuth: true,
                requiresAuthKey: 'HML_AIRCRAFT'
              }
            }, {
              name: 'High Mast Lighting',
              path: '',
              component: RouteWelcome,
              props: {
                systemHome: "/high-mast-lighting-area/welcome"
              }
            },
            {
              name: 'High Mast Lighting Welcome',
              path: 'welcome',
              component: Welcome,
              props: {
                headerText: 'Enterprise GIS - High Mast Lighting System',
                staticBackground: 'static/bg_hml.jpg'
              },
              meta: {
                title: 'Welcome'
              }
            }, {
              name: 'HMLAAMSAsset',
              path: 'aamsasset',
              component: HMLAamsAsset,
              meta: {
                title: 'AAMS Asset',
                requiresAuth: true,
                requiresAuthKey: 'HML_AAMS'
              }
            },
        ]

    },
    {
      path: '/airfield-ground-light-area', component: AGLAreaLayout,
        children: [
            {
              name: 'AGLAsset',
              path: 'asset',
              component: AGLAsset,
              meta: {
                title: 'Asset',
                requiresAuth: true,
                requiresAuthKey: 'AGL_ASSET',
                requiresAuthAdminKey: 'AGL_ADMIN'
              }
            }, {
              name: 'AGLReplacement',
              path: 'replacement',
              component: AGLReplacement,
              meta: {
                title: 'Replacement',
                requiresAuth: true,
                requiresAuthKey: 'AGL_REPLACEMENT',
                requiresAuthAdminKey: 'AGL_ADMIN'
              }
            },
            {
              name: 'AGLBoltInsp',
              path: 'bolt-insp',
              component: AGLBoltInsp,
              meta: {
                title: 'Bolt Inspection',
                requiresAuth: true,
                requiresAuthKey: 'AGL_BOLT',
                requiresAuthAdminKey: 'AGL_ADMIN'
              }
            }, {
              name: 'AGLEpoxyInsp',
              path: 'epoxy-insp',
              component: AGLEpoxyInsp,
              meta: {
                title: 'Epoxy Inspection',
                requiresAuth: true,
                requiresAuthKey: 'AGL_EPOXY',
                requiresAuthAdminKey: 'AGL_ADMIN'
              }
            }, {
              name: 'AGLAnalysis',
              path: 'analysis',
              component: AGLAnalysis,
              meta: {
                title: 'Analysis'
              }
            }, {
              name: 'AGLPhotometric',
              path: 'photometric',
              component: AGLPhotometric,
              meta: {
                title: 'Photometric',
                requiresAuth: true,
                requiresAuthKey: 'AGL_PHOTOMETRIC',
                requiresAuthAdminKey: 'AGL_ADMIN'
              }
            }, {
              name: 'Airfield Ground Light',
              path: '',
              component: RouteWelcome,
              props: {
                systemHome: "/airfield-ground-light-area/welcome"
              },
              meta: {
                title: 'Welcome'
              }
            }, {
              name: 'Airfield Ground Light Welcome',
              path: 'welcome',
              component: Welcome,
              props: {
                headerText: 'Enterprise GIS - Airfield Ground Lighting System',
                staticBackground: 'static/bg_agl.jpg'
              },
              meta: {
                title: 'Welcome'
              }
            }, {
              name: 'AGLAAMSAsset',
              path: 'aamsasset',
              component: AGLAAMSAsset,
              meta: {
                title: 'AAMS Asset',
                requiresAuth: true,
                requiresAuthKey: 'AGL_AAMS',
                requiresAuthAdminKey: 'AGL_ADMIN'
              }
            },

        ]

    },
    {
      path: '/potable-water-area', component: PotableWaterAreaLayout,
        children: [
            {
                name: 'Water Network',
                path: 'water-network',
                component: WaterNetwork,
                meta: {
                    title: 'Water Network',
                      requiresAuth: true,
                      requiresAuthKey: 'POT_NETWORK'
                }
            },
            {
                name: 'Leakage Detection',
                path: 'leakage-detection',
                component: LeakageDetection,
                meta: {
                    title: 'Leakage Detection',
                      requiresAuth: true,
                      requiresAuthKey: 'POT_LEAKAGE'
                }
            },
            {
                name: 'Intake',
                path: 'intake',
                component: Intake,
                meta: {
                    title: 'Intake',
                      requiresAuth: true,
                      requiresAuthKey: 'POT_INTAKE'
                }
            },
            {
                name: 'Simulation',
                path: 'simulation',
                component: Simulation,
                meta: {
                    title: 'Simulation',
                      requiresAuth: true,
                      requiresAuthKey: 'POT_SIMULATION'
                }
            }, {
              name: 'AssetAge',
              path: 'asset-age',
              component: AssetAge,
              meta: {
                title: 'Asset Age',
                  requiresAuth: true,
                  requiresAuthKey: 'POT_ASSET_AGE'
              }
            },
            {
                name: 'Potable Water Maintenance',
                path: 'maintenance',
                component: PotableWaterMaintenance,
                meta: {
                    title: 'Maintenance',
                      requiresAuth: true,
                      requiresAuthKey: 'POT_MAINTENANCE'
                }
            },
            {
                name: 'Inspection',
                path: 'inspection',
                component: Inspection,
                meta: {
                    title: 'Inspection',
                      requiresAuth: true,
                      requiresAuthKey: 'POT_INSPECTION'
                }
            },
            {
                name: 'Water Network - Table View',
                path: 'water-network-table-view',
                component: WaterNetworkTableView,
                meta: {
                    title:'Water Network Table View',
                }
            }, {
              name: 'Potable Water',
              path: '',
              component: RouteWelcome,
              props: {
                systemHome: "/potable-water-area/welcome"
              }
            },
            {
                name: 'Potable Water Welcome',
                path: 'welcome',
                component: PotableWaterWelcome, props: {
                    headerText: 'Enterprise GIS - Potable Water Supply System'
                },
                meta:{
                    title:'Welcome'
                }
            },
            {
              name: 'POT AAMS Asset',
              path: 'aamsasset',
              component: POTAamsAsset,
              meta: {
                  title: 'AAMS Asset',
                    requiresAuth: true,
                    requiresAuthKey: 'POT_AAMS'
              }
            },
        ]

    },
    {
      path: '/sewer-area', component: SewerAreaLayout,
      children: [
            {
              name: 'Sewer Water Welcome',
              path: 'welcome',
              component: Welcome,
              props: {
                headerText: 'Enterprise GIS - Sewerage System',
                staticBackground: 'static/bg_sewer.jpg',
                fontClass: 'font-grey'
              },
              meta:{
                  title:'Welcome'
              }
          }, {
            name: 'Sewer Water',
            path: '',
            component: RouteWelcome,
            props: {
              systemHome: "/sewer-area/welcome"
            },
            meta:{
              title: 'Welcome'
            }
          },{
            name: 'Sewer Asset',
            path: 'sewer-asset',
            component: SewerAsset,
            meta: {
                title:'Asset',
                requiresAuth: true,
                requiresAuthKey: 'SS_ASSET'
            }
          },{
            name: 'Sewer CCTV',
            path: 'sewer-cctv',
            component: SewerCCTV,
            meta: {
                title:'CCTV',
                requiresAuth: true,
                requiresAuthKey: 'SS_CCTV'

            }
          },{
            name: 'Sewer Relining',
            path: 'sewer-relining',
            component: SewerRelining,
            meta: {
                title:'Relining',
                requiresAuth: true,
                requiresAuthKey: 'SS_RELINING'
            }
          },{
            name: 'Sewer Water Maintenance',
            path: 'sewer-maintenance',
            component: SewerMaintenance,
            meta: {
                title:'Maintenance',
                requiresAuth: true,
                requiresAuthKey: 'SS_MAINTENANCE'
            }
          },{
            name: 'Sewer Simulation',
            path: 'sewer-simulation',
            component: SewerSimulation,
            meta: {
                title:'Simulation',
                requiresAuth: true,
                requiresAuthKey: 'SS_SIMULATION'
            }
          },{
            name: 'Sewer AAMS Asset',
            path: 'aamsasset',
            component: SewerAAMSAsset,
            meta: {
                title:'AAMS Asset',
                requiresAuth: true,
                requiresAuthKey: 'SS_AAMS'
            }
          }
      ]


    }
  ]
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js